import { isComplete, negotiate } from "../format";
import { joinEn, type JoinCatalog } from "./en";
import { joinFr } from "./fr";
import { joinSw } from "./sw";

export { joinEn, type JoinCatalog, type JoinMessageKey } from "./en";

const catalogs = { en: joinEn, sw: joinSw, fr: joinFr } as const;
type JoinLocale = keyof typeof catalogs;

/** Locales whose participant catalog is complete — the only ones a phone is offered. */
export const JOIN_LOCALES = (Object.keys(catalogs) as JoinLocale[]).filter((l) =>
  isComplete(joinEn, catalogs[l] as Record<string, string | undefined>),
);

/**
 * The participant's locale and strings. `preferences` in order of precedence, e.g. the
 * phone's languages and then the organisation's default.
 */
export function joinMessages(...preferences: Array<string | null | undefined>): {
  locale: string;
  messages: JoinCatalog;
} {
  const locale = negotiate(preferences.filter(Boolean).join(","), JOIN_LOCALES, "en");
  return { locale, messages: { ...joinEn, ...catalogs[locale] } };
}
